export default {
  user_type: [
    { id: 0, title: "Customer", value: "customer" },
    { id: 2, title: "Chef", value: "chef" },
    { id: 3, title: "Delivery Boy", value: "delivery_boy" }
  ],
  logo_url:"https://assets.plaptech.com/logo.png",
  favicon_url:"https://assets.plaptech.com/favicon.png",
};
